module.exports = __webpack_public_path__ + "static/media/destaque-44.f79b3ef6.png";